export const shadows = {
  none: 'none',
  surface: '0 1px 2px rgba(15, 23, 42, 0.04)',
  floating: '0 4px 12px rgba(15, 23, 42, 0.06)',
  dialog: '0 10px 30px rgba(15, 23, 42, 0.12)',
} as const;

export type ShadowRole = keyof typeof shadows;
